import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { ORDER_ROUTES } from './routes';
import { OrdersScreen } from '@/screens/orders/orders-screen';
import { OrdersStackParams } from './types';
import { SplitOrdersScreen } from '@/screens/orders/split-orders-screen';
import { SubscriptionsScreen } from '@/screens/subscriptions/subscriptions-screen';
import { useDefaultAppTabScreenOptions } from '@/hooks/use-default-app-tab-screen-options';
import { useLayoutContext } from '@/contexts/layout-context';

const Stack = createStackNavigator<OrdersStackParams>();

interface Props {
  initialCreditRequestUUID?: string;
  initialInvoiceUUID?: string;
  initialOrderUUID?: string;
}

export const OrdersStack: React.FC<Props> = ({
  initialCreditRequestUUID,
  initialInvoiceUUID,
  initialOrderUUID,
}) => {
  const screenOptions = useDefaultAppTabScreenOptions();
  const { isSmallLayout } = useLayoutContext();

  return (
    <Stack.Navigator
      initialRouteName={ORDER_ROUTES.Orders}
      screenOptions={screenOptions}
    >
      <Stack.Screen
        component={isSmallLayout ? OrdersScreen : SplitOrdersScreen}
        initialParams={{
          creditRequestUUID: initialCreditRequestUUID,
          invoiceUUID: initialInvoiceUUID,
          orderUUID: initialOrderUUID,
        }}
        name={ORDER_ROUTES.Orders}
      />
      <Stack.Screen
        component={SubscriptionsScreen}
        name={ORDER_ROUTES.Subscriptions}
      />
    </Stack.Navigator>
  );
};
